import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-overlay-host',
  templateUrl: './empty-overlay-host.component.html',
  styleUrls: ['./empty-overlay-host.component.scss']
})
export class EmptyOverlayHostComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
